// extracted by mini-css-extract-plugin
export default {"adminPagesWrap":"AdminPageLayout_adminPagesWrap__N8+r7","adminContent":"AdminPageLayout_adminContent__n2vGs"};